import { Group } from "@mantine/core"
import { IconExternalLink } from "@tabler/icons-react"
import { Anchor, Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { config } from "~/pages/Brand/DataTransfer/config.ts"

export const DataTransferWrapper = () => {
  const { t } = useTranslation("dataTransfer")

  const pages = useMemo<PageLink[]>(() => {
    return [
      {
        label: t("tabs.import"),
        link: "import",
      },
      {
        label: t("tabs.export"),
        link: "export",
      },
    ]
  }, [t])

  return (
    <Page
      title={t("page.title")}
      pages={pages}
      mainCta={
        <Anchor
          target="_blank"
          rel="noopener noreferrer"
          href={config.DATA_TRANSFER_DOCS}
        >
          <Group gap="xs" h="100%" align="center">
            {t("templateDocumentation")}
            <IconExternalLink size={16} />
          </Group>
        </Anchor>
      }
    />
  )
}
